export default "__VITE_ASSET__f4ca76f8__"